"use client";

import type { AnalyticsIdentity } from "@/lib/analytics/analytics-identity";
import dynamic from "next/dynamic";
import type { ReactElement } from "react";

const PostHogPageView = dynamic(() => import("./PostHogPageView"), {
  ssr: false,
});

/**
 * Lazy-loads {@link PostHogPageView} on the client only.
 *
 * @param identity - The server-resolved analytics identity, passed through unchanged.
 * @returns The lazily loaded tracker.
 */
export default function PostHogPageViewLazy({ identity }: { identity: AnalyticsIdentity }): ReactElement {
  return <PostHogPageView identity={identity} />;
}
